<div class="notification-stack" *ngIf="notifications.notifications$ | async as items">
  <div
    class="card notification-card"
    *ngFor="let item of items; trackBy: trackById"
    [ngClass]="'notification-card--' + item.level"
    [attr.role]="item.level === 'error' ? 'alert' : 'status'"
    [attr.aria-live]="levelAriaLive(item.level)"
    (mouseenter)="notifications.pause(item.id)"
    (mouseleave)="notifications.resume(item.id)"
    (focusin)="notifications.pause(item.id)"
    (focusout)="notifications.resume(item.id)"
  >
    <div class="notification-card-message">
      {{ item.message }}
      <span class="notification-card-repeat" *ngIf="item.repeatCount > 1">x{{ item.repeatCount }}</span>
    </div>
    <button
      type="button"
      class="btn btn--bare btn--sm"
      (click)="notifications.remove(item.id)"
      aria-label="Dismiss notification"
    >
      x
    </button>
  </div>
</div>
